export const PayType = {
  WithKdv: "WithKdv",
  WithoutKdv: "WithoutKdv",
  All: "All",
};
